import {Button, Div, Label} from 'components';
import React, {
  forwardRef,
  ReactNode,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import {widthScreen} from 'utils';
import {Ecolors} from 'constant';
import {FlatList, StyleSheet} from 'react-native';
import {navigationRef} from 'services';

export type TabRef = {
  goTo: (index: number) => void;
};

type Props = {
  data: IData[];
  multilanguage?: boolean;
  onChange?: (t: number) => void;
};

interface IData {
  Component: ReactNode;
  title: string;
  key: string;
}

function Tabbar(p: {
  activeTab: number;
  multilanguage?: boolean;
  data: Array<IData>;
  goToPage?: (e: number) => void;
}) {
  const flatlistRef = useRef<any>(null);
  const size =
    p.data?.length <= 3 ? widthScreen / p.data.length : widthScreen / 3;

  useEffect(() => {
    gotoActiveHeader(p.activeTab);
    return () => {};
  }, [p.activeTab]);

  const gotoActiveHeader = (index: number) => {
    if (flatlistRef.current) {
      flatlistRef.current.scrollToOffset({
        offset: (index > 0 ? index - 1 : index) * size,
        animated: true,
      });
    }
  };

  const renderItem = (t: {item: IData; index: number}) => {
    const {item, index} = t;
    const isFocus = p.activeTab == index;
    return (
      <Button
        onPress={() => {
          p.goToPage && p.goToPage(index);
        }}
        height={50}
        borderBottomWidth={2}
        borderBottomColor={isFocus ? Ecolors.mainColor : Ecolors.spaceColor}
        style={{
          width: size,
        }}
        alignItems={'center'}
        justifyContent={'center'}
        flexDirection={'row'}
        key={item.title}>
        <Label
          textAlign={'center'}
          multilanguage={p.multilanguage}
          size={14}
          fontWeight={'700'}
          color={isFocus ? Ecolors.textColor : Ecolors.grayColor}>
          {item.title}
        </Label>
      </Button>
    );
  };

  return (
    <Div backgroundColor={Ecolors.white}>
      <FlatList
        ref={flatlistRef}
        horizontal={true}
        showsHorizontalScrollIndicator={false}
        keyExtractor={(item: IData, index: number) => `key${item.key}`}
        data={p.data}
        extraData={p.data}
        renderItem={renderItem}
        getItemLayout={(data, index) => ({
          length: index * size,
          offset: index,
          index: index,
        })}
      />
    </Div>
  );
}

const TabViewComp = forwardRef<TabRef, Props>((Props, ref) => {
  const [activeTab, setActiveTab] = useState(0);

  useImperativeHandle(ref, () => ({
    goTo(index: number) {
      goToPage(index);
      navigationRef.setParams({
        initPage: undefined,
      });
    },
  }));

  const goToPage = (index: number) => {
    setActiveTab(index);
    Props.onChange && Props.onChange(index);
  };

  const Component = () => {
    const Component: any = Props.data?.[activeTab].Component;
    return (
      <Div
        style={{
          width: widthScreen,
          height: '100%',
        }}>
        <Component activeTab={activeTab} />
      </Div>
    );
  };
  return (
    <Div flex={1}>
      <Tabbar
        activeTab={activeTab}
        multilanguage={Props.multilanguage}
        data={Props.data}
        goToPage={goToPage}
      />

      <Div
        style={{
          width: widthScreen,
          height: '100%',
          marginTop: 10,
        }}>
        <Component />
      </Div>
    </Div>
  );
});

const styles = StyleSheet.create({
  viewPager: {
    flex: 1,
  },
});

export default TabViewComp;
